/* assets/cdt-bf-wheel.js — Black Friday teaser countdown + prize wheel (spec 2026-10-06 §8.4).
 *
 * Reads window.CDT_BF (bf.state_json, or bf.preview_json on an unpublished theme; set in layout/theme.liquid).
 * Acts only in the 'teaser' phase: fills the teaser texts, ticks the countdown, wires the wheel modal
 * (template #cdt-bf-wheel-tpl from snippets/cdt-bf-wheel.liquid), the floating "Învârte roata" button and
 * the minimised winner pill. Exposes priceAlert() for the Favorite toast in cdt-wishlist.js.
 *
 * WHEEL SLICE ORDER IS A CONTRACT with backend/services/blackFriday/core.js WHEEL_SLICES: slice s0..s7,
 * starting under the pointer (top) and going clockwise, is
 *   s0 free_shipping · s1 percent10 · s2 none · s3 percent15 · s4 free_shipping · s5 percent10 · s6 free_shipping · s7 percent10
 * The server answers slice_index; targetRotation(slice_index) lands that slice under the pointer.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.CdtBfWheel = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var SLICES = ['free_shipping', 'percent10', 'none', 'percent15', 'free_shipping', 'percent10', 'free_shipping', 'percent10'];

  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
  function countdownParts(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(t / 86400); t -= d * 86400;
    var h = Math.floor(t / 3600); t -= h * 3600;
    var m = Math.floor(t / 60); var s = t - m * 60;
    return { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
  }
  // Clockwise rotation (deg) that brings slice `sliceIndex` (centred at sliceIndex * step) under the top pointer.
  function targetRotation(sliceIndex, slices, turns, jitter) {
    slices = slices || 8; turns = turns == null ? 6 : turns; jitter = jitter || 0;
    var step = 360 / slices;
    return 360 * turns + ((360 - sliceIndex * step) % 360) + jitter;
  }
  /* DATA Reshape `email_subscribed` (owner 2026-10-16), pushed once per NEW wheel entry; Reshape fans it out as
     GA4 subscribe / Meta Subscribe / TikTok Subscribe. Single opt-in: the code e-mail goes out on the spin itself,
     so the push follows the API's 'won' answer. event.id comes from the address — one address, one event id. */
  function idHash(s) {
    var h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return ('0000000' + h.toString(16)).slice(-8);
  }
  // ShopifyAnalytics.meta.page.pageType → Reshape context.page_type
  var PAGE_TYPES = { home: 'home', product: 'product', collection: 'category', searchresults: 'search', cart: 'cart', page: 'page', blog: 'blog', article: 'article' };
  function subscribedEvent(email, prize, o) {
    o = o || {};
    var addr = String(email || '').trim();
    return {
      event: { name: 'email_subscribed', value: 1, currency: 'RON', id: 'bfwheel2026_' + idHash(addr.toLowerCase()),
        properties: { list_name: 'black_friday_wheel_2026', placement: o.placement || 'other', prize: (prize && prize.kind) || null, newsletter_opt_in: !!o.newsletter } },
      context: { url: o.url || '', page_type: PAGE_TYPES[o.pageType] || 'other', environment: o.prod === false ? 'dev' : 'prod' },
      user: { email: addr, country: 'RO' }
    };
  }
  // A tap on the wheel's centre (the gold hub) spins like the button — visitors tapped it expecting exactly that
  // (rage clicks, 2026-10-16). It presses the real button, so onSubmit's consent / e-mail checks still apply;
  // nothing happens mid-spin (form step hidden, button disabled) or after a win.
  function hubSpin(m) {
    var step = m && m.querySelector('[data-bf-step="form"]');
    var btn = step && step.querySelector('[data-bf-form] [type=submit]');
    if (!btn || step.hidden || btn.disabled) return false;
    btn.click();
    return true;
  }
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return { countdownParts: countdownParts, targetRotation: targetRotation, SLICES: SLICES, subscribedEvent: subscribedEvent, hubSpin: hubSpin };
  }

  var state = window.CDT_BF || { phase: 'off' };
  var LS_KEY = 'cdt_bf_wheel_2026';
  var PILL_HIDDEN = 'cdt_bf_pill_hidden';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function read() { try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(LS_KEY, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  function reducedMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  var HEADS = {
    form: ['Învârte roata lui Bandi', 'și câștigă un extra de Black Friday', 'Livrare gratuită, extra 10% sau extra 15%, pe 6 – 8 noiembrie. Codul vine pe e-mail.'],
    spinning: ['Învârte roata lui Bandi', 'și câștigă un extra de Black Friday', 'Livrare gratuită, extra 10% sau extra 15%, pe 6 – 8 noiembrie. Codul vine pe e-mail.'],
    won: ['Felicitări!', 'Premiul e al tău', 'Se adaugă peste toate reducerile de Black Friday.'],
    already: ['Ai învârtit deja', 'premiul e tot al tău', 'O singură învârtire pe adresă, ca să fie corect pentru toți.']
  };

  /* ── Teaser panel ──────────────────────────────────────────────────── */
  function startCountdown(el) {
    if (!el) return;
    var target = Date.parse(state.bf_start);
    if (!target) return;
    var wasRunning = target - Date.now() > 0; // never reload-loop a preview forced into teaser after bf_start
    var tick = function () {
      var left = target - Date.now();
      var p = countdownParts(left);
      ['d', 'h', 'm', 's'].forEach(function (k) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = p[k]; });
      if (left <= 0) { if (wasRunning) setTimeout(function () { location.reload(); }, 1500); return; }
      setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    };
    tick();
  }

  function fillTeaserTexts(rootEl) {
    var t = state.teaser || {};
    var set = function (sel, v) { var n = rootEl.querySelector(sel); if (n && v) n.textContent = v; };
    set('[data-bf-eyebrow]', t.eyebrow); set('[data-bf-title]', t.title); set('[data-bf-title-accent]', t.title_accent);
    set('[data-bf-subtitle]', t.subtitle); set('[data-bf-wheel-cta]', t.wheel_cta); set('[data-bf-fav-cta]', t.favourites_cta);
  }

  /* ── Modal ─────────────────────────────────────────────────────────── */
  var lastFocus = null;
  var spinTimer = null;
  function modal() {
    var m = document.getElementById('cdt-bf-wheel');
    if (m) return m;
    var tpl = document.getElementById('cdt-bf-wheel-tpl');
    if (!tpl) return null;
    m = document.createElement('div');
    m.id = 'cdt-bf-wheel'; m.className = 'cdt-bf-modal'; m.hidden = true;
    m.appendChild(tpl.content ? tpl.content.cloneNode(true) : document.createRange().createContextualFragment(tpl.innerHTML));
    document.body.appendChild(m);
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-bf-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (m.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'Tab') trapTab(m, e);
    });
    var form = m.querySelector('[data-bf-form]');
    form.addEventListener('submit', onSubmit);
    // The spin button is locked until the rules consent is ticked (the checks in onSubmit stay as the backstop).
    form.consent_rules.addEventListener('change', function () { gateSpin(form); });
    gateSpin(form);
    var hub = m.querySelector('.cdt-bf-hub');
    if (hub) hub.addEventListener('click', function () { hubSpin(m); });
    var resend = m.querySelector('[data-bf-resend]');
    if (resend) resend.addEventListener('click', onResend);
    return m;
  }
  function trapTab(m, e) {
    var f = Array.prototype.filter.call(m.querySelectorAll('button, a[href], input:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null && !n.disabled; });
    if (!f.length) return;
    var first = f[0]; var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function show(step) {
    var m = modal();
    var headKey = step === 'won' && m.dataset.already === '1' ? 'already' : step;
    var h = HEADS[headKey] || HEADS.form;
    m.querySelector('[data-bf-head-a]').textContent = h[0];
    m.querySelector('[data-bf-head-b]').textContent = h[1];
    m.querySelector('[data-bf-head-sub]').textContent = h[2];
    m.dataset.step = step;
    m.querySelectorAll('[data-bf-step]').forEach(function (s) { s.hidden = s.dataset.bfStep !== step; });
  }
  var openedFrom = 'other'; // Reshape properties.placement
  function placementOf(el) {
    if (!el || !el.closest) return 'other';
    if (el.closest('.cdt-bf-float')) return 'floating_button';
    if (el.closest('.cdt-bf-strip__link')) return 'top_strip';
    if (el.closest('[data-bf-teaser]')) return 'teaser';
    return 'other';
  }
  function open(e) {
    var m = modal();
    if (!m) return;
    lastFocus = (e && e.currentTarget) || document.activeElement;
    openedFrom = placementOf(e && e.currentTarget);
    var saved = read();
    m.hidden = false;
    document.documentElement.classList.add('cdt-bf-lock');
    iosNoAutoZoom(true);
    if (saved && saved.prize) {
      setDisc(targetRotation(saved.slice_index || 0, 8, 0, 0), false);
      renderWon(saved, true);
      var c = m.querySelector('.cdt-bf-continue'); if (c) c.focus();
    } else {
      setDisc(0, false);
      show('form');
      /* Owner 2026-10-08: no auto-focus on the e-mail field — on phones it popped the keyboard (and iOS zoomed in)
         before the shopper had even seen the wheel. Focus the dialog itself instead (keyboard users Tab into the form). */
      var dlg = m.querySelector('.cdt-bf-dialog');
      if (dlg) { dlg.setAttribute('tabindex', '-1'); dlg.focus({ preventScroll: true }); }
    }
  }
  function close() {
    var m = modal();
    if (!m || m.hidden) return;
    // Mid-spin (Escape, ×, backdrop): stay open, so the prize is never revealed before the wheel stops.
    if (m.dataset.step === 'spinning') return;
    m.hidden = true;
    document.documentElement.classList.remove('cdt-bf-lock');
    iosNoAutoZoom(false);
    try { sessionStorage.removeItem(PILL_HIDDEN); } catch (err) { /* noop */ }
    renderPill();
    if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus();
    else { var p = document.getElementById('cdt-bf-pill'); if (p) p.focus(); }
  }

  function setDisc(deg, animate) {
    var disc = modal().querySelector('[data-bf-disc]');
    disc.style.transition = 'none';
    if (!animate) { disc.style.transform = 'rotate(' + deg + 'deg)'; return; }
    disc.style.transform = 'rotate(0deg)';
    void disc.offsetWidth; // commit the reset before the animated turn
    disc.style.transition = 'transform 4.2s cubic-bezier(.12,.72,.16,1)';
    disc.style.transform = 'rotate(' + deg + 'deg)';
    tickPointer(disc);
  }
  /* Wheel v2: the pointer flicks each time a slice divider passes under it (read from the live transform, so it
     follows the easing exactly and slows down with the wheel). */
  function tickPointer(disc) {
    var ptr = modal().querySelector('.cdt-bf-pointer');
    if (!ptr || !window.requestAnimationFrame || reducedMotion()) return;
    var last = null, t0 = Date.now();
    var loop = function () {
      var tr = getComputedStyle(disc).transform;
      var ang = 0;
      if (tr && tr !== 'none') { var v = tr.split('(')[1].split(')')[0].split(','); ang = Math.atan2(parseFloat(v[1]), parseFloat(v[0])) * 180 / Math.PI; }
      var sector = Math.floor((((ang + 22.5) % 360) + 360) % 360 / 45);
      if (last !== null && sector !== last) { ptr.classList.remove('is-tick'); void ptr.getBoundingClientRect(); ptr.classList.add('is-tick'); }
      last = sector;
      if (Date.now() - t0 < 4400) requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  function prizeNote(prize) {
    if (prize.kind === 'none') return '';
    return prize.min_order ? 'la comenzi de minimum ' + prize.min_order + ' lei' : 'la comanda ta, fără valoare minimă';
  }
  function renderWon(r, already) {
    var m = modal();
    m.dataset.already = already ? '1' : '0';
    m.querySelector('[data-bf-prize-title]').textContent = r.prize.label;
    m.querySelector('[data-bf-prize-note]').textContent = prizeNote(r.prize);
    var kind = r.prize.kind || 'free_shipping';
    m.querySelectorAll('[data-bf-prize-icon]').forEach(function (i) { i.hidden = i.dataset.bfPrizeIcon !== kind; });
    m.querySelectorAll('[data-bf-email]').forEach(function (n) { n.textContent = r.email || ''; });
    m.querySelector('[data-bf-already]').hidden = !already;
    var done = m.querySelector('[data-bf-resend-done]'); if (done) done.hidden = true;
    show('won');
  }

  /* The spin button LOOKS locked until the rules consent is ticked, but stays tappable: a tap then explains why
     (owner 2026-10-08 — a disabled button swallowed the tap with no feedback). */
  function gateSpin(f) {
    var b = f.querySelector('[type=submit]');
    if (!b) return;
    b.disabled = false;
    var locked = !f.consent_rules.checked;
    b.classList.toggle('is-locked', locked);
    b.setAttribute('aria-disabled', locked ? 'true' : 'false');
    if (!locked) { var err = f.querySelector('[data-bf-error]'); if (err && err.dataset.kind === 'consent') err.hidden = true; }
  }
  /* iOS zooms into a focused field; while the wheel is open the viewport gets maximum-scale=1 (iOS still allows
     pinch-zoom with it), restored on close. Other platforms are left alone. */
  var vpOrig = null;
  function iosNoAutoZoom(on) {
    var ios = /iP(hone|od|ad)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var meta = document.querySelector('meta[name=viewport]');
    if (!ios || !meta) return;
    if (on) { if (vpOrig === null) vpOrig = meta.getAttribute('content') || ''; meta.setAttribute('content', vpOrig.replace(/,?\s*maximum-scale=[^,]*/g, '') + ', maximum-scale=1'); }
    else if (vpOrig !== null) { meta.setAttribute('content', vpOrig); vpOrig = null; }
  }
  var RO_MONTHS = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
  // wheel_closed carries a reason from the API; before the window the honest message is the start date, not "s-a încheiat".
  function closedMessage(ex) {
    if (!ex || ex.message !== 'wheel_closed') return null;
    if (ex.reason === 'not_started' && typeof ex.starts_at === 'string' && ex.starts_at.length >= 10) {
      var day = parseInt(ex.starts_at.slice(8, 10), 10), month = parseInt(ex.starts_at.slice(5, 7), 10) - 1;
      if (day > 0 && RO_MONTHS[month]) return 'Roata pornește pe ' + day + ' ' + RO_MONTHS[month] + '. Revino atunci!';
    }
    if (ex.reason === 'inactive') return 'Roata nu e activă momentan. Revino în curând.';
    return ERRORS.wheel_closed;
  }
  var ERRORS = {
    wheel_closed: 'Roata s-a încheiat.',
    invalid_email: 'Adresa nu pare completă. Ex.: nume@gmail.com',
    consent_required: 'Bifează acordul cu regulamentul ca să poți învârti.',
    rate_limited: 'Prea multe încercări. Mai încearcă peste un minut.',
    // e-mail guard (API answers 400 with one of these; email_suspicious can be confirmed once)
    email_domain: 'Adresa asta nu poate primi e-mailuri, așa că n-ai primi codul. Verifică ce ai scris după @.',
    email_disposable: 'Adresele de e-mail temporare nu sunt acceptate: codul trebuie să ajungă în căsuța ta.',
    email_placeholder: 'Scrie adresa ta reală de e-mail: acolo îți trimitem codul.',
    email_suspicious: 'Adresa pare scrisă greșit. E corectă?'
  };
  var EMAIL_ISSUES = { email_domain: 1, email_disposable: 1, email_placeholder: 1, email_suspicious: 1 };
  var confirmedEmail = null; // the address the visitor said is correct ("Da, e corectă")
  function issueButton(label, onClick) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cdt-bf-error__btn'; b.textContent = label;
    b.addEventListener('click', onClick);
    return b;
  }
  // Message + the way out: use the suggested address, or confirm an odd-looking one and spin again.
  function showEmailIssue(f, code, suggestion, email) {
    var err = f.querySelector('[data-bf-error]');
    err.textContent = '';
    var msg = document.createElement('span');
    if (suggestion) {
      msg.appendChild(document.createTextNode('Ai vrut să scrii '));
      var b = document.createElement('b'); b.textContent = suggestion; msg.appendChild(b);
      msg.appendChild(document.createTextNode('?'));
    } else msg.textContent = ERRORS[code];
    err.appendChild(msg);
    if (suggestion) err.appendChild(issueButton('Da, folosește-o', function () {
      f.email.value = suggestion; err.hidden = true; f.email.removeAttribute('aria-invalid'); f.email.focus();
    }));
    if (code === 'email_suspicious') err.appendChild(issueButton(suggestion ? 'Nu, adresa mea e corectă' : 'Da, e corectă', function () {
      confirmedEmail = email; err.hidden = true;
      if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true }));
    }));
    err.hidden = false; err.dataset.kind = 'email';
    f.email.setAttribute('aria-invalid', 'true');
  }
  function showError(f, msg, field) {
    var err = f.querySelector('[data-bf-error]');
    err.textContent = msg; err.hidden = false; err.dataset.kind = field || '';
    f.email.setAttribute('aria-invalid', field === 'email' ? 'true' : 'false');
    if (field === 'email') f.email.focus();
    else if (field === 'consent') f.consent_rules.focus();
  }

  function onSubmit(e) {
    e.preventDefault();
    var f = e.currentTarget;
    var email = f.email.value.trim();
    var err = f.querySelector('[data-bf-error]');
    err.hidden = true; f.email.removeAttribute('aria-invalid');
    if (!f.consent_rules.checked) return showError(f, ERRORS.consent_required, 'consent');
    if (!EMAIL_RE.test(email)) return showError(f, ERRORS.invalid_email, 'email');
    if (!state.wheel || !state.wheel.api) return showError(f, 'Nu am putut învârti acum. Încearcă din nou.');
    show('spinning');
    var submitBtn = f.querySelector('[type=submit]'); submitBtn.disabled = true;
    var res;
    fetch(state.wheel.api + '/wheel/spin', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, consent_rules: true, consent_newsletter: !!f.consent_newsletter.checked, website: f.website.value,
        confirm_email: confirmedEmail !== null && confirmedEmail === email })
    }).then(function (r) { res = r; return r.json(); }).then(function (r) {
      if (!res.ok || !r || !r.prize) throw Object.assign(new Error((r && r.error) || 'error'), { reason: r && r.reason, starts_at: r && r.starts_at, suggestion: r && r.suggestion });
      var slice = Number(r.slice_index);
      if (!(slice >= 0 && slice < SLICES.length)) slice = 0;
      // Land inside the slice, never on a divider (half-slice = 22.5deg).
      var jitter = r.prize.kind === 'percent15' ? 8 + Math.random() * 10 : Math.random() * 20 - 10;
      var saved = { prize: r.prize, email: email, slice_index: slice };
      write(saved);
      var already = r.status === 'already';
      // A new entry only ('already' was counted on its first spin); a filled honeypot gets a fake 'won' from the API.
      if (r.status === 'won' && r.prize.kind !== 'none' && !f.website.value) trackSubscribed(email, r.prize, !!f.consent_newsletter.checked);
      if (reducedMotion()) {
        setDisc(targetRotation(slice, 8, 0, 0), false);
        renderWon(saved, already);
      } else {
        setDisc(targetRotation(slice, 8, 6, jitter), true);
        clearTimeout(spinTimer);
        spinTimer = setTimeout(function () { renderWon(saved, already); }, 4300);
      }
      var fb = document.querySelector('.cdt-bf-float'); if (fb) fb.remove();
    }).catch(function (ex) {
      show('form');
      if (ex && EMAIL_ISSUES[ex.message]) return showEmailIssue(f, ex.message, ex.suggestion, email);
      showError(f, closedMessage(ex) || ERRORS[ex && ex.message] || 'Nu am putut învârti acum. Încearcă din nou.');
    }).then(function () { gateSpin(f); });
  }

  function trackSubscribed(email, prize, newsletter) {
    try {
      var page = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; // 'main' = the published theme
      window.reshape = window.reshape || [];
      window.reshape.push(subscribedEvent(email, prize, { placement: openedFrom, newsletter: newsletter, url: location.href,
        pageType: page && page.pageType, prod: !role || role === 'main' }));
    } catch (ex) { /* tracking never breaks the wheel */ }
  }

  function onResend() {
    var saved = read();
    var done = modal().querySelector('[data-bf-resend-done]');
    if (!saved || !saved.email || !state.wheel || !state.wheel.api) return;
    fetch(state.wheel.api + '/wheel/resend', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: saved.email }) })
      .then(function (r) { done.textContent = r.ok ? 'Gata, ți-l retrimitem în câteva minute.' : 'Nu am putut retrimite acum. Încearcă mai târziu.'; done.hidden = false; })
      .catch(function () { done.textContent = 'Nu am putut retrimite acum. Încearcă mai târziu.'; done.hidden = false; });
  }

  /* ── Floating button + minimised winner pill ───────────────────────── */
  function hiddenPill() { try { return sessionStorage.getItem(PILL_HIDDEN) === '1'; } catch (e) { return false; } }
  function renderPill() {
    var saved = read();
    var pill = document.getElementById('cdt-bf-pill');
    if (!saved || !saved.prize || saved.prize.kind === 'none' || state.phase !== 'teaser' || hiddenPill()) { if (pill) pill.remove(); return; }
    if (!pill) {
      pill = document.createElement('div');
      pill.id = 'cdt-bf-pill'; pill.className = 'cdt-bf-pill-float';
      pill.innerHTML = '<button type="button" class="cdt-bf-pill-float__open"><span class="cdt-bf-pill-float__ic" aria-hidden="true"></span>'
        + '<span class="cdt-bf-pill-float__txt"><strong></strong><span>Activ pe 6 – 8 noiembrie · codul e în e-mail</span></span></button>'
        + '<button type="button" class="cdt-bf-pill-float__x" aria-label="Ascunde">×</button>';
      document.body.appendChild(pill);
      pill.querySelector('.cdt-bf-pill-float__open').addEventListener('click', open);
      pill.querySelector('.cdt-bf-pill-float__x').addEventListener('click', function () {
        try { sessionStorage.setItem(PILL_HIDDEN, '1'); } catch (e) { /* noop */ }
        pill.remove();
      });
    }
    pill.querySelector('strong').textContent = 'Premiul tău: ' + saved.prize.label;
  }

  function floatingButton() {
    if (read() || document.querySelector('.cdt-bf-float')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cdt-bf-float'; b.setAttribute('aria-label', 'Învârte roata Black Friday');
    var av = (state.wheel && state.wheel.bandi_avatar) || '';
    b.innerHTML = (av ? '<img class="cdt-bf-float__bandi" src="' + av + '" width="40" height="40" alt="" aria-hidden="true">' : '<span class="cdt-bf-mini-wheel" aria-hidden="true"></span>')
      + 'Învârte roata<span class="cdt-bf-float__extra">· extra de BF</span>';
    b.addEventListener('click', open);
    document.body.appendChild(b);
  }

  /* ── Price alert (used by cdt-wishlist.js) ─────────────────────────── */
  function priceAlert(email, visitorId) {
    if (!state.wheel || !state.wheel.api) return Promise.resolve(false);
    return fetch(state.wheel.api + '/price-alert', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      // hard e-mail checks still apply server-side; the "e corectă?" question is skipped in this small form
      body: JSON.stringify({ email: email, visitor_id: visitorId || null, confirm_email: true })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function knownEmail() { var s = read(); return (s && s.email) || null; }

  function init() {
    if (state.phase !== 'teaser') return;
    var teaser = document.querySelector('[data-bf-teaser]');
    if (teaser) { fillTeaserTexts(teaser); startCountdown(teaser.querySelector('[data-bf-countdown]')); }
    var wheelOpen = !!(state.wheel && state.wheel.open && document.getElementById('cdt-bf-wheel-tpl'));
    document.querySelectorAll('[data-bf-open-wheel]').forEach(function (b) {
      if (wheelOpen) b.addEventListener('click', open); else b.hidden = true;
    });
    if (wheelOpen) floatingButton();
    renderPill();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  return { countdownParts: countdownParts, targetRotation: targetRotation, SLICES: SLICES, open: open, priceAlert: priceAlert, knownEmail: knownEmail };
});
